/* Centralize Data Management */

// Data Management

// Cache

// Get Local Cache

// Get Server Cache (From Redis);


// Save Local Data for next time launching

// Clear Local Data (Vuex Store States)
export async function purgeStoreState(context) {
  const { commit } = context;
  // States from Core module
  
    commit("Dev/removeDevData");

    // User state (Current User/Profile)
    commit("removeUserState");
    commit("removeUserProfile");

  // States from 
    // commit("Student/removeStudentEnroll");
    // commit("Student/removeStudentEnrollDetails");

    commit("Classroom/purgeClassroom");

    commit("ClassSection/purgeClassSection");

    commit("Classroom/purgeClassroom");

    commit("CourseFaq/purgeCourseFaqs");

    commit("CourseOutlineRegistration/purgeCourseOutlineRegistration");

    commit("Examination/purgeExamination");

    commit("LiveClass/purgeLiveClass");

    commit("Notification/purgeNotifications");

    commit("PrivateMessage/purgePrivateMessages");

    commit("PrivateMessageReply/purgePrivateMessageReplies");

    commit("StudentAssignment/purgeStudentAssignment");

    commit("WebBoard/purgeWebboard");

    commit("WebBoardReply/purgeWebboardReplies");

}
